import { ITimeSlotDetails } from "@/api/AppApi/services/time-slots/interfaces/api-time-slots-interfces";
import Price from "@/app/components/lib/Price";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { Col, Row } from "@/utils/bootstrap";
import { FieldValues, UseFormReturn } from "react-hook-form";
import SvgSlotTime from "../day-appointments-icons/SvgSlotTime";
import TimeSlotBtn from "./TimeSlotBtn";
import { IuseProductHasAttrsResult } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
import ProtectedContent from "@/app/components/common-builder/product/product-box/product-box-helpers/ProtectedContent";
import useSellingMode from "@/hooks/useSellingMode";

interface Props {
  slot: ITimeSlotDetails;
  beside: boolean;
  agreeTerms: boolean;
  form: UseFormReturn<FieldValues, any>;
  productId: number;
  redirectToCheckout: boolean;
  productState?: IuseProductHasAttrsResult;
}

const TimeSlot: React.FC<Props> = ({
  slot,
  beside,
  agreeTerms,
  productId,
  redirectToCheckout,
  form,
  productState,
}) => {
  const t = useTranslation();
  const { enableAddToCart } = useSellingMode();
  return (
    <Row key={slot.id} className="m-0 align-items-center">
      <Col className="p-0 slot">
        <div className="slot-date">
          <SvgSlotTime />
          <bdi>{slot.start_at}</bdi>
          {" - "}
          <bdi>{slot.end_at}</bdi>
        </div>
        {slot.appointment_id ? (
          <div className="booked">{t.appointment_booked} </div>
        ) : (
          <Price
            price={{
              value: slot.price + (productState?.selectedAddOnsPrice || 0),
              className: "slot-price",
            }}
            roundPrice
          />
        )}
      </Col>
      <Col className="p-0 col-auto">
        <ProtectedContent showChildren={enableAddToCart} smallText>
          <TimeSlotBtn
            form={form}
            agreeTerms={agreeTerms}
            redirectToCheckout={redirectToCheckout}
            beside={beside}
            slot={slot}
            productId={productId}
            productState={productState}
          />
        </ProtectedContent>
      </Col>
    </Row>
  );
};

export default TimeSlot;
